import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadVoidAtom = createMutationAtomFactory(
  'trade.purchaseLoadVoid',
  (params: { id: string; voidReason?: string }) => ({
    tradePurchaseLoadVoid: {
      __args: {
        id: params.id,
        voidReason: params.voidReason,
      },
    },
  }),
);
